import React from "react";
import ParameterQuickEditInput from "../../../../parts/inputs/parameter-quick-edit-input";
import { mapParameter } from "../../../../parts/other-exercise/CustomParametersSets";
import SvgIcon from "../../../../parts/SvgIcon";

const {
  PARAMETER_OPTIONS: { FREEFORM },
} = require("../../../../constants");

const NewExerciseLineParameters = ({
  newSet,
  exId,
  setIndex,
  _handleNewSetChange,
  activeExercise,
  activeUser,
  _handleCloseAddSet,
  _handleSaveNewSetForOther,
  isProgramEditor,
}) => (
  <div className="parameters-pb">
    {activeExercise.parameters.map((elem, index) => (
      <span
        className={`${elem === FREEFORM ? "text-left! basis-3/5!" : ""}`}
        key={`new_${index}_${elem}_parameter`}
      >
        <ParameterQuickEditInput
          id={`new_${exId}_${setIndex}_${elem.toLowerCase()}`}
          name={mapParameter(elem)}
          defaultValue={newSet[mapParameter(elem)]}
          onInput={(e) => e && e.target.value && _handleNewSetChange(e, null)}
          parameter={elem}
          onChange={(e) => e && e.target.value && _handleNewSetChange(e, null)}
          keyParam={`new_${exId}_${setIndex}_${elem.toLowerCase()}`}
          units={activeUser.units}
        />
      </span>
    ))}

    <span className="add-delete-set">
      <button
        data-button-type="primary"
        onClick={(e) =>
          _handleSaveNewSetForOther(
            e,
            exId,
            setIndex,
            activeUser,
            activeExercise
          )
        }
      >
        <SvgIcon src="/img/new-icons/check.svg" noFilterOnLight />
      </button>
      <button
        data-button-type="secondary"
        onClick={(e) => _handleCloseAddSet(e)}
      >
        <SvgIcon src="/img/new-icons/red-cross-20px.svg" noFilterOnLight />
      </button>
    </span>
    {!isProgramEditor && <span />}
  </div>
);

export default NewExerciseLineParameters;
